import { MiddleName } from '@dreryk/person-name-common-api';

import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

type MiddleNameFieldProps = FieldControllerProps<'middleName', string | null>;

export const MiddleNameField = (props: MiddleNameFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register(props.name, {
            required: props.required,
            maxLength: MiddleName.MAX_LENGTH,
         })}
         label={commonTranslationKeys.middleName}
         testId={props.name}
         defaultValue={props.defaultValue}
      />
   );
};
